import { AxiosResponse } from 'axios'

// realisations
import { http } from '../realisations/Http.realisation'

// types
import {
    DeliveryIndividualShipmentCostPayload,
    DeliveryIndividualStandardParamsPayload,
    GetDeliveryShipmentCostsParams,
    GetDeliveryShipmentCostsResponse,
    GetDeliveryStandardParamsParams,
    GetDeliveryStandardParamsResponse,
} from '@/core/types/delivery-shipment-costs.types'

export class DeliveryShipmentCostsRepository {
    getShipmentCosts(
        params: GetDeliveryShipmentCostsParams
    ): Promise<AxiosResponse<GetDeliveryShipmentCostsResponse>> {
        return http.get('/billing/api/delivery/delivery-shipment-costs', { params })
    }

    getStandardParams(
        params: GetDeliveryStandardParamsParams
    ): Promise<AxiosResponse<GetDeliveryStandardParamsResponse>> {
        return http.get('/billing/api/delivery/delivery-standard-params', { params })
    }

    createIndividualShipmentCost(
        payload: DeliveryIndividualShipmentCostPayload
    ): Promise<AxiosResponse<void>> {
        return http.post('/billing/api/delivery/delivery-shipment-costs/individual', payload)
    }

    createIndividualStandardParams(
        payload: DeliveryIndividualStandardParamsPayload
    ): Promise<AxiosResponse<void>> {
        return http.post('/billing/api/delivery/delivery-standard-params/individual', payload)
    }

    updateIndividualShipmentCost(
        payload: DeliveryIndividualShipmentCostPayload
    ): Promise<AxiosResponse<void>> {
        return http.put(`/billing/api/delivery/delivery-shipment-costs/individual/update`, payload)
    }

    updateIndividualStandardParams(
        payload: DeliveryIndividualStandardParamsPayload
    ): Promise<AxiosResponse<void>> {
        return http.put('/billing/api/delivery/delivery-standard-params/individual/update', payload)
    }
}
